import { render, staticRenderFns } from "./NotificationEventList.vue?vue&type=template&id=439a6dca&scoped=true"
import script from "./NotificationEventList.vue?vue&type=script&lang=js"
export * from "./NotificationEventList.vue?vue&type=script&lang=js"
import style0 from "./NotificationEventList.vue?vue&type=style&index=0&id=439a6dca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439a6dca",
  null
  
)

export default component.exports